import { useAuth } from '../features/auth/auth-context.js';
import { useCurrency } from '../features/currency/currency-context.js';

export function SettingsPage() {
  const { user } = useAuth();
  const { displayCurrency, fxTable, fxStatus } = useCurrency();

  return (
    <div className="stack">
      <h1 className="page-title">Beállítások</h1>

      <section className="card">
        <h2 className="card__title">Fiók</h2>
        <dl className="definitions">
          <dt>E-mail</dt>
          <dd data-testid="account-email">{user?.email ?? '—'}</dd>
          <dt>Felhasználó azonosító</dt>
          <dd className="mono">{user?.id ?? '—'}</dd>
          <dt>Megjelenítési deviza</dt>
          <dd>{displayCurrency}</dd>
        </dl>
      </section>

      <section className="card">
        <h2 className="card__title">Árfolyamok</h2>
        <dl className="definitions">
          <dt>Állapot</dt>
          <dd>{fxStatus}</dd>
          <dt>Betöltött árfolyamok</dt>
          <dd className="numeric">{fxTable?.size ?? 0}</dd>
          <dt>Legfrissebb nap</dt>
          <dd>{fxTable?.latestDate() ?? '—'}</dd>
        </dl>
        <p className="muted">
          Az árfolyamtábla a kliensen van, ezért a devizaváltás nem indít szerverhívást.
        </p>
      </section>

      <section className="card">
        <h2 className="card__title">Integrációk</h2>
        <p className="muted">
          Az IBKR, a Revolut és a K&amp;H bekötése a 4. fázisban készül el. Addig a portfólió és a
          költések kézzel és CSV importtal vezethetők.
        </p>
      </section>
    </div>
  );
}
